import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import {makeStyles} from '@material-ui/core/styles';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import React from 'react';
import {usePreferencesState} from '../Preferences/PreferencesProvider';

const useStyles = makeStyles(theme => ({
    link: {
        color: theme.palette.primary[theme.palette.type === 'light' ? 'main' : 'light'],
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    icon: {
        marginLeft: theme.spacing(1),
        fontSize: 16,
    },
}));

type Props = {
    open : boolean;
    onClose : () => void;
};

const BookmarksDialog : React.FC<Props> = ({open, onClose} : Props) => {
    const classes = useStyles();
    const {linkGroups} = usePreferencesState().preferences.dashboard;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>Bookmarks</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    {linkGroups.map((linkGroup, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                            <Card>
                                <CardHeader title={linkGroup.name}/>
                                <List dense component="div">
                                    {linkGroup.links.map((link, index) => (
                                        <ListItem
                                            key={index}
                                            component="a"
                                            href={link.url}
                                            target={link.openInNew ? '_blank' : '_self'}
                                            rel="noopener"
                                            className={classes.link}
                                        >
                                            <ListItemText>
                                                {link.title}
                                                {link.openInNew && <OpenInNewIcon className={classes.icon}/>}
                                            </ListItemText>
                                        </ListItem>
                                    ))}
                                </List>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default BookmarksDialog;
